import { useUserStore } from '@/store/user';
import { useParams } from 'react-router-dom';

export const useClient = () => {
  const { clients } = useUserStore();
  const { client } = useParams();

  if (!client || Object.keys(clients).length === 0) return undefined;

  return clients[client];
};
